module.exports = __webpack_public_path__ + "img/home.4727da18.jpg";